import { useContext, useEffect, useState } from "react";

import { AiFillHome } from "react-icons/ai";
import { FaUsers, FaWifi } from "react-icons/fa";
import { TfiAngleLeft } from "react-icons/tfi";
import { BsFillAlarmFill } from "react-icons/bs";
import { IoLogOutSharp, IoSettings } from "react-icons/io5";
import { BiSolidHelpCircle } from "react-icons/bi";
import { FaBookOpenReader } from "react-icons/fa6";

import { FaBed } from "react-icons/fa";
import { MdSignalWifiConnectedNoInternet2 } from "react-icons/md";
import { IoIosWifi } from "react-icons/io";
import "material-icons/iconfont/material-icons.css";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { DasboardContext } from "../../context/dashboard-context";
import { useAuth } from "../../context/auth-context";

import { Link } from "react-router-dom";

import logo from "../../assets/images/logo.png";
import kilavuzPdf from "../../assets/kılavuz.pdf";
import "./style.css";

const Sidebar = () => {
  const { sidebarOpen, setSidebarOpen, setUserInfo } =
    useContext(DasboardContext);
  const { logout } = useAuth();

  const [show, setShow] = useState(false);
  const [confirmLogout, setConfirmLogout] = useState(false);
  const isMobile = window.innerWidth <= 768;

  const handleLogout = async () => {
    setUserInfo(null);
    localStorage.setItem("hasRefreshed", "false");
    await logout();
  };

  return (
    <div className={`sidebar-wrapper ${sidebarOpen ? "" : "close"}`}>
      <div className="logo-wrapper">
        <img src={logo} alt="logo" />
        <TfiAngleLeft onClick={() => setSidebarOpen(true)} />
      </div>

      <div className="menu-wrapper">
        <div className="side-menu">
          <AiFillHome />
          <Link to={"/homepage"}>Ana Ekran</Link>
        </div>
        {!isMobile && (
          <div className="side-menu">
            <FaUsers />
            <Link to={"/user-list"}>Kullanıcılar</Link>
          </div>
        )}
        <div className="side-menu">
          <FaWifi />
          <Link to={"/devices"}>Cihazlar</Link>
        </div>
        <div className="side-menu">
          <BsFillAlarmFill />
          <Link to={"/alarms"}>Alarm</Link>
        </div>
        <div className="side-menu">
          <IoSettings />
          <Link to="/login-detail">Ayarlar</Link>
        </div>

        <div className="side-menu" onClick={() => setShow(true)}>
          <BiSolidHelpCircle />
          <a href="#">Yardım</a>
        </div>
        <div 
          className="side-menu" 
          onClick={() => window.open(kilavuzPdf, "_blank")}
          style={{ cursor: "pointer" }}
        >
          <FaBookOpenReader />
          <a href="#" onClick={(e) => e.preventDefault()}>Kılavuz</a>
        </div>

        {/* ✅ Çıkış butonu artık modal açıyor */}
        <div className="side-menu" onClick={() => setConfirmLogout(true)}>
          <IoLogOutSharp />
          <p>Çıkış Yap</p>
        </div>
      </div>

      {/* 🔹 Yardım Modali */}
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Arayüz Hakkında Bilgilendirme</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-container">
            <div className="modal-info">
              <FaBed size={20} />
              <p>Bu ikon odadaki yatağın boş olduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <FaBed color="orange" size={20} />
              <p>Bu ikon kişinin yatakta bulunduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <span className="material-symbols-rounded">countertops</span>
              <p>Bu ikon odanın mutfak olduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <span className="material-symbols-rounded">bathtub</span>
              <p>Bu ikon odanın banyo olduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <span className="material-symbols-rounded">king_bed</span>
              <p>Bu ikon odanın yatak odası olduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <span className="material-symbols-rounded">table_restaurant</span>
              <p>Bu ikon odanın yemek odası olduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <span className="material-symbols-rounded">scene</span>
              <p>Bu ikon odanın oturma odası olduğunu işaret etmektedir</p>
            </div>
            <div className="modal-info">
              <p>
                Her ikonun aktif olarak yanan turuncu hali, kişinin oda
                içerisinde olduğunu belirtmektedir.
              </p>
            </div>
            <div className="modal-info">
              <MdSignalWifiConnectedNoInternet2 color="red" size={20} />
              <p>
                Bu ikon odadaki cihazın çevrimdışı olduğuna işaret etmektedir
              </p>
            </div>
            <div className="modal-info">
              <IoIosWifi color="green" size={20} />
              <p>
                Bu ikon odadaki cihazın çevrimiçi olduğunu işaret etmektedir
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 🔹 Çıkış onay modali */}
      <Modal
        show={confirmLogout}
        onHide={() => setConfirmLogout(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Çıkış Yap</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Çıkış yapmak istediğinizden emin misiniz?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmLogout(false)}>
            Hayır
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setConfirmLogout(false);
              handleLogout();
            }}
          >
            Evet, Çıkış Yap
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Sidebar;
